class Integration {
	id;
	name;
	type;

	static Type = {
		SKIDATA: "skidata",
		OMNIRIS: "omniris"
	};

	static from(fields) {
		if (!fields.type || fields.type === "skidata") {
			return new SkidataIntegration(fields);
		}
	}
}

export class SkidataIntegration {
	id;
	type = "skidata";
	name = "";
	enabled = false;
	hsh_ip = "";
	hsh_issuer = 1;
	hsh_receiver = 1;
	hsh_port = 443;
	hsh_use_https = false;
	hsh_unsecure_https = false;
	add_new_checkpoints = false;
	checkpoints = [];
	properties = [];
	checklistsCount = 0;
	api_url = "";
	api_username = "";

	constructor(fields = {}) {
		Object.assign(this, fields); // note we need to map properties to SkidataProperty
		this.properties =
			fields.properties?.map(p => new SkidataProperty(p)) ?? [];
		this.checklistsCount = fields.checklists_count || 0;
	}

	toJSON() {
		return {
			id: this.id,
			type: this.type,
			name: this.name,
			enabled: this.enabled,
			hsh_ip: this.hsh_ip,
			hsh_issuer: this.hsh_issuer,
			hsh_receiver: this.hsh_receiver,
			hsh_port: this.hsh_port,
			hsh_use_https: this.hsh_use_https,
			hsh_unsecure_https: this.hsh_unsecure_https,
			add_new_checkpoints: this.add_new_checkpoints,
			checkpoints: this.checkpoints,
			properties: this.properties,
			checklists_count: this.checklistsCount,
			api_url: this.api_url,
			api_username: this.api_username
		};
	}

	static buildFromJSON(json) {
		return new SkidataIntegration({
			id: json.id,
			type: json.type,
			name: json.name,
			enabled: json.enabled,
			hsh_ip: json.hsh_ip,
			hsh_issuer: json.hsh_issuer,
			hsh_receiver: json.hsh_receiver,
			hsh_port: json.hsh_port,
			hsh_use_https: json.hsh_use_https,
			hsh_unsecure_https: json.hsh_unsecure_https,
			add_new_checkpoints: json.add_new_checkpoints,
			checkpoints: json.checkpoints,
			properties: json.properties,
			checklists_count: json.checklists_count,
			api_url: json.api_url,
			api_username: json.api_username
		});
	}
}

export class SkidataProperty {
	id;
	property = "";
	value = "";
	mapping = [];
	type = "static";
	model = "AccessRight";
	null_value = null;

	constructor(fields = {}) {
		Object.assign(this, fields);
		this.mapping =
			fields.mapping?.map(r => new SkidataPropertyReplacement(r)) ?? [];
	}
}

export class SkidataPropertyReplacement {
	source = "";
	value = "";

	constructor(fields = {}) {
		Object.assign(this, fields);
	}
}

export default Integration;
